module.exports = __webpack_public_path__ + "assets/img/phone.9dbfd399.png";